export default __webpack_public_path__ + "a839db3a548c364031aa00e6d36f804c.ttf";